<mat-form-field
  [appearance]="appearance()"
  [floatLabel]="floatLabel()"
  class="w-full"
>
  <mat-label>{{ label() }}</mat-label>
  <mat-select
    [formControl]="control"
    multiple
    [id]="id()"
    [placeholder]="placeholder()"
    [compareWith]="compareItems"
  >
    @if (showSelectAll) {
      <div class="select-all-option" (mousedown)="$event.preventDefault()">
        <mat-checkbox
          [checked]="allSelected"
          [indeterminate]="someSelected"
          (change)="toggleSelectAll()"
        >
          {{
            (allSelected ? 'GENERAL.deselect_all' : 'GENERAL.select_all')
              | translate
          }}
        </mat-checkbox>
      </div>
    }
    <mat-option
      [value]="null"
      disabled
      [style.display]="items()?.length ? 'none' : ''"
    >
      {{ 'GENERAL.no_results_found' | translate }}
    </mat-option>
    @for (item of items(); track item?.id) {
      <mat-option
        [value]="item"
        [disabled]="disabledField() || isOptionDisabled(item)"
        >{{ item.name }}</mat-option
      >
    }
  </mat-select>
  <mat-error siatErrorField [control]="control" [label]="label()"></mat-error>
</mat-form-field>
